mutation RequestTranscribeToken {
    transcribeToken {
        token
        limitInfo {
            shouldShowWarningInTrial
            currentUsage
            allTimeUsage
            currentPlanLimit
            isEnforced
            canAdd
            currentPlanName
            upgradePlanLimit
            upgradePlanName
            tierPlanLimit
            humanReadableType
        }
    }
}
